import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-2xl font-bold text-black-main" }
const _hoisted_2 = { class: "container mt-6" }
const _hoisted_3 = { class: "text-xs text-portal-grey" }
const _hoisted_4 = { class: "flex mt-14 space-x-4 justify-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CpsTextarea = _resolveComponent("CpsTextarea")!
  const _component_CpsButton = _resolveComponent("CpsButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.t("Deposit_Enter_Hash_Id")), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.t("Deposit_Enter_Hash_Id_Description")), 1),
      _createVNode(_component_CpsTextarea, {
        value: _ctx.hashId,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.hashId) = $event)),
        validators: _ctx.inputPattern,
        validatorMessageMap: _ctx.textareaValidatorMessageMap,
        required: "",
        trimInput: ""
      }, null, 8, ["value", "validators", "validatorMessageMap"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_CpsButton, {
        class: "w-full",
        type: 'cancel',
        onClick: _ctx.cancel
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t("Deposit_Cancel")), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_CpsButton, {
        class: "w-full",
        disabled: !_ctx.isValid,
        onClick: _ctx.submit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t("Deposit_Submit")), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ]))
}